// extracted by mini-css-extract-plugin
export default {"shoeSizeContainer":"ShoeSize_shoeSizeContainer__RLPkG","ranger":"ShoeSize_ranger__ueeS9","manualInput":"ShoeSize_manualInput__wrahQ"};